import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=831afa60&scoped=true&"
import script from "./DrawerMenu.vue?vue&type=script&lang=js&"
export * from "./DrawerMenu.vue?vue&type=script&lang=js&"
import style0 from "./DrawerMenu.vue?vue&type=style&index=0&id=831afa60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831afa60",
  null
  
)

export default component.exports